<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>
<app-toast></app-toast>
